import { MouseEventHandler, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button, BUTTON_MODE } from '@components/Button';
import { ITransactionNeededData } from '@/state/slice/transactionDetailSlice';
import { CURRENCY } from '@constants/common.constants';
import BillingRefundCard from './BillingRefundCard';
import CountDownCircleTimer from '@components/CountdownCircleTimer';

interface ConfirmRefundTransactionDialogProps {
	title?: string;
	message: string;
	transactionDetail: Partial<ITransactionNeededData>;
	onProceed: () => void;
	onCancel: MouseEventHandler<HTMLButtonElement>;
}

export function ConfirmRefundTransactionDialog({ title = 'Confirm', transactionDetail, message, onProceed, onCancel }: ConfirmRefundTransactionDialogProps) {
	const [showCountdown, setShowCountdown] = useState<boolean>(false);
	const handleShowCountdown = () => {
		setShowCountdown(true);
	};
	return createPortal(
		<div className='transition duration-100 ease-in-out w-screen h-screen top-0 left-0 bg-black bg-opacity-80 flex flex-col justify-center items-center fixed z-40 overflow-y-auto p-6'>
			<div className='flex flex-col w-full desktop:w-[790px] bg-white rounded-lg relative p-6 justify-center items-center'>
				{!showCountdown ? (
					<>
						<p className='text-xl text-center font-semibold w-full'>{title}</p>
						<p className='mt-4 text-base leading-[17.05px] font-normal w-full text-center'>{message}</p>
						<div className='mt-4 mobile:w-full tablet:w-[584px] desktop:w-[584px] tablet:max-h-full mobile:max-h-[250px] overflow-x-hidden overflow-y-auto'>
							<BillingRefundCard
								date={transactionDetail.createdAt}
								amount={transactionDetail.amount}
								billingTransactions={transactionDetail.details}
								referenceId={transactionDetail._id}
								currency={transactionDetail.currency as CURRENCY}
							/>
						</div>
						<Button mode={BUTTON_MODE.ROUNDED} className='w-full tablet:w-[279px] mt-6' onClick={handleShowCountdown}>
							Confirm
						</Button>
						<Button mode={BUTTON_MODE.LIGHT} className='w-full tablet:w-[279px] mt-4' onClick={onCancel}>
							Cancel
						</Button>
					</>
				) : (
					<div className='flex flex-col py-6'>
						<p className='mb-10 text-center text-xl'>Processing your refund.</p>
						<CountDownCircleTimer time={5} onComplete={onProceed} />
						<Button mode={BUTTON_MODE.LIGHT} className='w-[279px] mt-16' onClick={onCancel}>
							Cancel
						</Button>
					</div>
				)}
			</div>
		</div>,
		document.body,
	);
}
